import React from "react";
import './sponsors_section.css';

// reactstrap components
import {
    Button,
    CardImg,
    CardText,
    CardSubtitle,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Container,
    Col,
    Row
} from "reactstrap";

class Sponsors extends React.Component {
    constructor(props) {
        super(props);
        }

    render() {
        return (
            <section id="sponsors" className="sponsors fullpage-section" style={{paddingTop: '10vh', paddingBottom: '10vh'}}>
                <Container>
                    <h1>OUR SPONSORS</h1>
                    <Row>
                        <Col xs="6" sm="4">
                            <Card>
                                <div className="sponsor-img" id="nvidia"></div>
                            </Card>
                        </Col>
                        <Col xs="6" sm="4">
                            <Card>
                                <div className="sponsor-img" id="pcbway"></div>
                            </Card>
                        </Col>
                        <Col sm="4">
                            <div className="sponsor-img" id="altium"></div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="6" sm="4">
                            <div className="sponsor-img" id="protocase"></div>
                        </Col>
                        <Col xs="6" sm="4">
                        <div className="sponsor-img" id="ansys"></div>

                        
                        </Col>
                        <Col sm="4">
                            <div className="sponsor-img" id="muj"></div>
                        </Col>
                    </Row>
                </Container>


            </section>
        );
    }
}

export default Sponsors;
